export function minutesBetweenDates(date1: Date, date2: Date): number {
  const diffMilliseconds: number = Math.abs(date1.getTime() - date2.getTime())

  const diffMinutes: number = diffMilliseconds / (1000 * 60)

  return diffMinutes
}
